import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as sha1 from 'sha1';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrServiceLocal } from 'src/app/services/toast/toastr.service';
import { EncuestasService } from '../encuestas.service';

@Component({
  selector: 'app-validar-usuario',
  templateUrl: './validar-usuario.component.html',
  styleUrls: ['./validar-usuario.component.scss']
})
export class ValidarUsuarioComponent implements OnInit {




  public formLogin: FormGroup;
  public suscripciones: Subscription = new Subscription();

  constructor(private toastr: ToastrService, public srv: EncuestasService, public router: Router, public toast: ToastrServiceLocal) {
    this.formLogin = new FormGroup({
      correo: new FormControl('',),
      noColegiacion: new FormControl(''),
      telefonoMovil: new FormControl('')
    });


  }

  ngOnInit(): void {

  }

  login() {
    // if (this.formLogin.invalid) {
    //   this.formLogin.markAllAsTouched();
    //   return;
    // }
    // console.log(this.formLogin.value);

    this.srv.validarUsuario(this.formLogin.value,data=>{
      // console.log(data)
      if (data.data.table0[0]) {
        this.router.navigateByUrl('/preguntas');
      }
    })
  }



}
